import React from 'react';
import { css } from '@emotion/core';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { addHoverStyle } from 'styles/common';
import { convertRGBtoRGBA } from 'utils/colorConvert';
import Popup from 'client/components/Popup';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import { white, system900, functional } from 'Mui/styles/color';

const useStyle = makeStyles({
    endButton: () =>
        addHoverStyle({
            backgroundColor: functional.color,
            color: white.color,
            '& *': {
                color: white.color
            }
        }),
    popup: {
        backgroundColor: white.color,
        '& .MuiDialogTitle-root .MuiTypography-root': {
            color: system900.color
        },
        margin: '16px'
    }
});

export default function PopupWinnerGet({ isOpen, title, onConfirm, btnText, imgSrc, label }) {
    const themeStyle = usePromoSettingThemeStyle();
    const style = useStyle(themeStyle);

    return (
        <Popup
            className={style.popup}
            isOpen={isOpen}
            title={title}
            onConfirm={onConfirm}
            endButton={btnText}
            endButtonStyle={style.endButton}
            backdropStyle={{ backgroundColor: convertRGBtoRGBA(themeStyle.contentBgColor, 0.5) }}
        >
            <div css={modalContentStyle}>
                {Boolean(imgSrc) && <img css={prizeImageStyle} src={imgSrc} alt={label} />}
                <Typography
                    variant="subtitle2"
                    css={[prizeTextStyle, css(`color: ${system900.color};`)]}
                >
                    {label}
                </Typography>
            </div>
        </Popup>
    );
}

const modalContentStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const prizeImageStyle = css`
    width: auto;
    max-width: 160px;
    max-height: 400px;
`;

const prizeTextStyle = css`
    padding: 8px 16px;
    text-align: center;
`;
